import TomSelect from "tom-select";
import { transliterate as tr } from 'transliteration';

const getPlaceholder = (select) => {
    const value = select.value;
    const option = select.querySelector(`[value='${value}']`);
    return option ? option.innerText : select.placeholder;
};

const addOption = (select, value) => {
    const option = document.createElement('option');
    option.value = value;
    option.innerHTML = value;

    select.appendChild(option);
}

window.initSelect2 = function ({ select, content, input, trigger }, data) {
    select.classList.add('hidden');
    trigger.classList.remove('hidden');

    const tSelect = new TomSelect(select, {
        width: data.width,
        create: JSON.parse(data.create),
        maxOptions: null,
        allowEmptyOption: JSON.parse(data.allowEmpty),
        optionClass: 'm-dropdown-option',
        dropdownContentClass: 'm-dropdown-content',
        dropdownParent: content,
        controlInput: input,
        onInitialize: function() {
            if (!select.value && data.model) {
                let option = select.querySelector(`[value='${data.model}']`)
                if (!option) {
                    addOption(select, data.model)
                }

                select.value = data.model;
            }

            input.placeholder = getPlaceholder(select, data.model);
        },
        onFocus: function() {
            data.open = true;
        },
        onBlur: function() {
            data.open = false;
        },
        onChange: function (value) {
            data.model = value;
            data.open = false;

            input.placeholder = getPlaceholder(select, data.model);

            this.blur();
        },
        render: {
            item: function (data, escape) {
                return `<div class="hidden">${escape(data.text)}</div>`;
            },
            option_create: function (data, escape) {
                return `<div class="create ${this.settings.optionClass}">Добавить <strong>${escape(data.input)}</strong>&hellip;</div>`;
            },
            no_results: function (data, escape) {
                return `<div class="no-results ${this.settings.optionClass}">Не найдено...</div>`;
            },
            dropdown: function () {
                return '<div class="max-h-60 overflow-y-auto"></div>'
            },
        },
        searchField: [
            { field: 'text', weight: 2 },
            { field: 'text_tr', weight: 1 },
        ],
        score: function(search) {
            const score = this.getScoreFunction(search);
            return function(item) {
                return score({'text_tr': tr(item.text), ...item});
            };
        },
    });

    if (data.id && document.querySelector(`label[for=${data.id}]`)) {
        document.querySelector(`[for=${data.id}]`).addEventListener('click',  () => tSelect.focus());
    }

    window.addEventListener('refresh-select2', (event) => {
        select.value = data.model;
        input.placeholder = getPlaceholder(select);
    });
}
